const scoreRouteLength = (route) => route.url.split('/').length

const sortRoutesByDescendingPathLength = (routes) => [...routes].sort(
  (a, b) => scoreRouteLength(a) > scoreRouteLength(b) ? -1 : 1
)

export default sortRoutesByDescendingPathLength